import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Modal,ModalWrapper} from '@workboard/wobo-ui';
import styled from "styled-components";
import { useTranslation } from 'react-i18next';
const StyledModal = styled(Modal)`
  ${ModalWrapper} {
    width: 640px;
  }
`;

const JiraIntegrationPopupBasic = (props) => {
  const [url, setUrl] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [urlError, setUrlError] = useState(false);
  const [error, setError] = useState(false);
  const [loginError, setLoginError] = useState(false);
  const [isOpen,setIsOpen] = useState(true);
  const { t } = useTranslation()

  const loginJiraAuth = (event) => {
    event.preventDefault();
    setLoginError(false);
    const trimmedUrl = url.trim().toLowerCase();
    const trimmedUsername = username.trim();
    let error;
    let urlError;
    if (!trimmedUrl 
            || !(trimmedUrl.indexOf('http') === 0 && trimmedUrl[trimmedUrl.length - 1] === '/')) {
      urlError = true;
    } else {
      urlError = false;
    }
    if (!trimmedUsername || !password) {
      error = true;
    } else {
      error = false;
    }

    if (!error && !urlError) {
      setError(false);
      setUrlError(false);
      $.ajax({
        url: `${wbConfig.baseUrl}/integration/hello`,
        type: 'POST',
        data: {
          app: 'jira',
          jira_app_url: url,
          user_name: username,
          user_password: password,
          scope: 'token'
        }
      }).then((response) => {
          if (response) {
            if (typeof response.data === 'string') {
              setLoginError(true);
            } else {
              props.updateParentState(url, response.data);
              props.closePopup(false);
            }
          }
          else {
            setLoginError(true);
          }
        });
    } else {
      if (urlError) setUrlError(true);
      if (error) setError(true);
    }
  };
  return (
    <StyledModal
      title= {t('Connect Jira Instance')}
      onSubmit={loginJiraAuth}
      onDismiss = {()=>props.closePopup(true)}
      isOpen={isOpen}
      className="login-jira-basic-auth"
      submitLabel={t('Connect')}
      dismissLabel={t('Cancel')}
      style={{zIndex: 1000000}}
    >
      <div className="login-jira-body" >
        <div className="login-jira-details">
          {t('Allow Workboard to access your Jira account by providing your')} {t('Jira credentials and API token.')}
        </div>
        <label htmlFor="jiraUrl">
                    {t('Public Jira URL')}<span className="typefacetext">*</span>
        </label>
        <div className="login-jira-input-error-container">
          <input
            type="text"
            className={urlError ? 'error' : ''}
            name="url"
            value={url}
            id="jiraUrl"
            placeholder={`${t('Ex')}: https://${t('example.atlassian.net')}/`}
            onChange={(e) => setUrl(e.currentTarget.value)}
            aria-required="true"
            aria-invalid= {urlError ? 'true' : 'false'} 
          />
          {urlError && (
          <span
            id="link-error"
            role="alert"
            className="login-jira-error-msg login-jira-error-msg-show"
          >
            {`${t('Please enter a valid')} \
                        ${t('link including')} 'http://' ${t('or')} 'https://' ${t('and ending with')} '/'`}
          </span>
          )}
        </div>
        <label htmlFor="jiraUserName">
                    {t('Username')}<span className="typefacetext">*</span>
        </label>
        <input
          type="text"
          className={!username.length && error ? 'error' : ''}
          name="username"
          value={username}
          placeholder={`${t('Ex')}: name@domain.com`}
          onChange={(e) => setUsername(e.currentTarget.value)}
          id = "jiraUserName"
          aria-required="true"
          aria-invalid= {!username.length && error ? 'true' : 'false'}
        />
        <label htmlFor="jiraToken">
                    {t('Jira API token')}<span className="typefacetext">*</span>
        </label>
        <div className="login-jira-token-container">
          <input
            type="password"
            className={!password.length && error ? 'error' : ''}
            name="password"
            value={password}
            placeholder={`${t('Ex')}: ${t('a1b2c3d4e5')}`}
            onChange={(e) => setPassword(e.currentTarget.value)}
            id = "jiraToken"
            autoComplete="off"
            aria-required="true"
            aria-invalid= {!password.length && error ? 'true' : 'false'}
          />
          <a
            href="https://id.atlassian.com/manage/api-tokens"
            className="link"
            target="_blank"
          >{t('Generate API token')}
          </a>
        </div>
      </div>
      { loginError && (
      <div className="login-jira-footer" role="alert">
        <span className={`login-jira-error-msg ${loginError ? 'login-jira-error-msg-show' : ''}`} >
          {`${t('Authorization failed')} - ${t('verify your public Jira URL, username,')} \
                    ${t('and/or personal access token.')}`}
        </span>
      </div>
      )}
    </StyledModal>
  );
};

export default JiraIntegrationPopupBasic;
